import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Card,
  Typography
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Page from 'src/components/Page';
import { useLocation, useNavigate } from 'react-router-dom';
import palette from 'src/theme/palette';
import Iconify from 'src/components/Iconify';
import { api } from 'src/Api';
import SubProjectTable from 'src/layouts/SubProjectComponents/SubProjectTable';
import AddEditSubProjectModal from 'src/layouts/SubProjectComponents/AddEditSubProjectModal';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import Searchbar from 'src/layouts/dashboard/Searchbar';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import ProjectManagerDropdown from 'src/components/ProjectManagerDropdown';
import FilterMultiDropdown from 'src/components/FilterMultiDropdown';
import LoaderModal from 'src/components/LoaderModal';

export default function SubProjectList() {
  const latestFilterRequest = useRef(0);
  const navigate = useNavigate();
  const location = useLocation();
  const intervalRefSub = useRef();
  const token = localStorage.getItem('token');
  const { projectData } = location.state || {};
  const initialLoadDone = useRef(false);

  const [loading, setloading] = useState(false);
  // const [search, setsearch] = useState('');
  const [showAddEditModal, setShowAddEditModal] = useState(false);

  const [list, setlist] = useState([]);
  const [pagination, setPagination] = useState({});

  const [uploadFileLoaderSub, setuploadFileLoaderSub] = useState(false);
  const [fileStatusSub, setfileStatusSub] = useState({});
  const [showSuccessModalSub, setshowSuccessModalSub] = useState(false);
  const [successTimerSub, setsuccessTimerSub] = useState(5);

  const [subProjectsList, setSubProjectsList] = useState([]);
  const [taskCodesList, setTaskCodesList] = useState([]);
  const [taskNamesList, setTaskNamesList] = useState([]);
  const [taskDescriptionsList, setTaskDescriptionsList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [sellsList, setSellsList] = useState([]);

  const [SelectedsubProjects, setSelectedSubProjects] = useState('all');
  const [SelectedtaskCodes, setSelectedTaskCodes] = useState('all');
  const [SelectedtaskNames, setSelectedTaskNames] = useState('all');
  const [SelectedtaskDescriptions, setSelectedTaskDescriptions] = useState('all');
  const [Selectedcategories, setSelectedCategories] = useState('all');
  const [Selectedsells, setSelectedSells] = useState('all');

  const [tempSelectedSubProjects, setTempSelectedSubProjects] = useState('all');
  const [tempSelectedTaskCodes, setTempSelectedTaskCodes] = useState('all');
  const [tempSelectedTaskNames, setTempSelectedTaskNames] = useState('all');
  const [tempSelectedTaskDescriptions, setTempSelectedTaskDescriptions] = useState('all');
  const [tempSelectedCategories, setTempSelectedCategories] = useState('all');
  const [tempSelectedSells, setTempSelectedSells] = useState('all');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [permission, setpermission] = useState([]);

  const requirement = [
    'add sub project',
    'upload file',
    'edit sub project',
    'add task',
    'delete sub project',
    'edit task',
    'delete task'
  ];

  function checkRender() {
    let check = 'projects';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );

    localPerm[0]?.permission_types?.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }

  useEffect(() => {
    checkRender();
    getAllFiltersDropDown();
    getCurrentProcessingFileData();
  }, []);

  // Show modal when status is completed
  useEffect(() => {
    if (fileStatusSub?.status === 'completed') {
      setshowSuccessModalSub(true);
      setsuccessTimerSub(5);
    }
  }, [fileStatusSub?.status]);

  // Timer countdown and close modal + refresh list
  useEffect(() => {
    if (!showSuccessModalSub) return;
    if (successTimerSub === 0) {
      setshowSuccessModalSub(false);
      gstSubProjectList(1);
      return;
    }
    const timer = setTimeout(() => setsuccessTimerSub((t) => t - 1), 1000);
    return () => clearTimeout(timer);
  }, [showSuccessModalSub, successTimerSub]);

  useEffect(() => {
    if (fileStatusSub?.status === 'processing') {
      getCurrentProcessingFileData(); // initial call
      if (!intervalRefSub.current) {
        intervalRefSub.current = setInterval(() => {
          getCurrentProcessingFileData();
        }, 10000);
      }
    } else {
      // status processing se hat gaya, interval clear karo
      if (intervalRefSub.current) {
        clearInterval(intervalRefSub.current);
        intervalRefSub.current = null;
      }
    }
    // Cleanup on unmount
    return () => {
      if (intervalRefSub.current) {
        clearInterval(intervalRefSub.current);
        intervalRefSub.current = null;
      }
    };
  }, [fileStatusSub?.status]);

  useEffect(() => {
    if (pagination && Object.keys(pagination).length > 0) {
      list.length = 0;
      gstSubProjectList(pagination.current_page);
    }
  }, [pagination.current_page]);

  // useEffect(() => {
  //   list.length = 0;
  //   gstSubProjectList(1);
  // }, []);

  useEffect(() => {
    if (
      !initialLoadDone.current &&
      (subProjectsList.length > 0 ||
        taskCodesList.length > 0 ||
        taskNamesList.length > 0 ||
        taskDescriptionsList.length > 0 ||
        categoriesList.length > 0 ||
        sellsList.length > 0)
    ) {
      initialLoadDone.current = true; // ensure sirf ek dafa chale
      gstSubProjectList(1);
    }
  }, [
    subProjectsList.length,
    taskCodesList.length,
    taskNamesList.length,
    taskDescriptionsList.length,
    categoriesList.length,
    sellsList.length
  ]);

  function gstSubProjectList(page, values = {}) {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const queryParams = new URLSearchParams();
    page && queryParams.append('page', page);
    // search.length > 0 && queryParams.append('search', search);
    projectData?.id && queryParams.append('project_id', projectData?.id);

    // Helper function to prepare value
    const makeValue = (val, selectedVal) => {
      if (val !== undefined) {
        if (Array.isArray(val) && val.length === 0) return JSON.stringify([]);
        if (val === 'all') return 'all';
        return JSON.stringify(val);
      } else {
        if (selectedVal === 'all') return 'all';
        if (Array.isArray(selectedVal) && selectedVal.length === 0) return JSON.stringify([]);
        return JSON.stringify(selectedVal);
      }
    };

    // 🟩 Only this one goes in API query params
    const subProjectValue = makeValue(values.sub_project, SelectedsubProjects);
    queryParams.append('sub_project_ids', subProjectValue);

    // 🟦 All other filters only go to localStorage (not API)
    const filtersToSave = [
      { key: 'task_code_ids', val: values.task_code, selected: SelectedtaskCodes },
      { key: 'task_name_ids', val: values.task_name, selected: SelectedtaskNames },
      {
        key: 'task_description_ids',
        val: values.task_desc,
        selected: SelectedtaskDescriptions
      },
      { key: 'task_category_ids', val: values.category, selected: Selectedcategories },
      { key: 'task_sel_ids', val: values.sel, selected: Selectedsells }
    ];

    filtersToSave.forEach(({ key, val, selected }) => {
      const finalValue = makeValue(val, selected);
      localStorage.setItem(key, finalValue); // ✅ Save only in localStorage
    });

    queryParams.append(
      'task_code_ids',
      values.task_code !== undefined
        ? Array.isArray(values.task_code) && values.task_code.length === 0
          ? JSON.stringify([])
          : values.task_code === 'all'
          ? 'all'
          : JSON.stringify(values.task_code)
        : SelectedtaskCodes === 'all'
        ? 'all'
        : Array.isArray(SelectedtaskCodes) && SelectedtaskCodes.length === 0
        ? JSON.stringify([])
        : JSON.stringify(SelectedtaskCodes)
    );

    queryParams.append(
      'task_name_ids',
      values.task_name !== undefined
        ? Array.isArray(values.task_name) && values.task_name.length === 0
          ? JSON.stringify([])
          : values.task_name === 'all'
          ? 'all'
          : JSON.stringify(values.task_name)
        : SelectedtaskNames === 'all'
        ? 'all'
        : Array.isArray(SelectedtaskNames) && SelectedtaskNames.length === 0
        ? JSON.stringify([])
        : JSON.stringify(SelectedtaskNames)
    );

    queryParams.append(
      'task_description_ids',
      values.task_desc !== undefined
        ? Array.isArray(values.task_desc) && values.task_desc.length === 0
          ? JSON.stringify([])
          : values.task_desc === 'all'
          ? 'all'
          : JSON.stringify(values.task_desc)
        : SelectedtaskDescriptions === 'all'
        ? 'all'
        : Array.isArray(SelectedtaskDescriptions) && SelectedtaskDescriptions.length === 0
        ? JSON.stringify([])
        : JSON.stringify(SelectedtaskDescriptions)
    );

    queryParams.append(
      'task_category_ids',
      values.category !== undefined
        ? Array.isArray(values.category) && values.category.length === 0
          ? JSON.stringify([])
          : values.category === 'all'
          ? 'all'
          : JSON.stringify(values.category)
        : Selectedcategories === 'all'
        ? 'all'
        : Array.isArray(Selectedcategories) && Selectedcategories.length === 0
        ? JSON.stringify([])
        : JSON.stringify(Selectedcategories)
    );

    queryParams.append(
      'task_sel_ids',
      values.sel !== undefined
        ? Array.isArray(values.sel) && values.sel.length === 0
          ? JSON.stringify([])
          : values.sel === 'all'
          ? 'all'
          : JSON.stringify(values.sel)
        : Selectedsells === 'all'
        ? 'all'
        : Array.isArray(Selectedsells) && Selectedsells.length === 0
        ? JSON.stringify([])
        : JSON.stringify(Selectedsells)
    );

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders
    };

    fetch(`${api.get_sub_projects}?${queryParams.toString()}`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to fetch Deal data');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setlist(result?.data);
        setPagination(result.pagination);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {});
  }

  function handleSelection({
    selectionValue, // e.g. result?.sub_project_selection
    itemsList, // e.g. result?.sub_projects
    setSelectedState, // e.g. setSelectedSubProjects
    setTempSelectedState // e.g. setTempSelectedSubProjects
  }) {
    if (selectionValue === 'all') {
      setSelectedState('all');
      setTempSelectedState('all');
    } else {
      try {
        const parsedArray = JSON.parse(selectionValue);
        const filteredItems = itemsList?.filter((item) => parsedArray?.includes(item.id));
        const selectedIds = filteredItems?.map((item) => item.id) || [];

        setSelectedState(selectedIds);
        setTempSelectedState(selectedIds);
      } catch (error) {
        console.error('Error parsing selection value:', error);
        setSelectedState([]);
        setTempSelectedState([]);
      }
    }
  }

  function getAllFiltersDropDown(currentSelection = 'all', values = {}) {
    latestFilterRequest.current += 1;
    const thisRequest = latestFilterRequest.current;
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    const formDataToSend = new FormData();

    projectData?.id && formDataToSend.append('project_id', projectData?.id);

    // Use values if provided, else fallback to state
    formDataToSend.append(
      'sub_project_selection',
      values.sub_project !== undefined
        ? Array.isArray(values.sub_project) && values.sub_project.length === 0
          ? JSON.stringify([])
          : values.sub_project === 'all'
          ? 'all'
          : JSON.stringify(values.sub_project)
        : SelectedsubProjects === 'all'
        ? 'all'
        : Array.isArray(SelectedsubProjects) && SelectedsubProjects.length === 0
        ? JSON.stringify([])
        : JSON.stringify(SelectedsubProjects)
    );

    formDataToSend.append(
      'task_code_selection',
      values.task_code !== undefined
        ? Array.isArray(values.task_code) && values.task_code.length === 0
          ? JSON.stringify([])
          : values.task_code === 'all'
          ? 'all'
          : JSON.stringify(values.task_code)
        : SelectedtaskCodes === 'all'
        ? 'all'
        : Array.isArray(SelectedtaskCodes) && SelectedtaskCodes.length === 0
        ? JSON.stringify([])
        : JSON.stringify(SelectedtaskCodes)
    );

    formDataToSend.append(
      'task_name_selection',
      values.task_name !== undefined
        ? Array.isArray(values.task_name) && values.task_name.length === 0
          ? JSON.stringify([])
          : values.task_name === 'all'
          ? 'all'
          : JSON.stringify(values.task_name)
        : SelectedtaskNames === 'all'
        ? 'all'
        : Array.isArray(SelectedtaskNames) && SelectedtaskNames.length === 0
        ? JSON.stringify([])
        : JSON.stringify(SelectedtaskNames)
    );

    formDataToSend.append(
      'task_desc_selection',
      values.task_desc !== undefined
        ? Array.isArray(values.task_desc) && values.task_desc.length === 0
          ? JSON.stringify([])
          : values.task_desc === 'all'
          ? 'all'
          : JSON.stringify(values.task_desc)
        : SelectedtaskDescriptions === 'all'
        ? 'all'
        : Array.isArray(SelectedtaskDescriptions) && SelectedtaskDescriptions.length === 0
        ? JSON.stringify([])
        : JSON.stringify(SelectedtaskDescriptions)
    );

    formDataToSend.append(
      'category_selection',
      values.category !== undefined
        ? Array.isArray(values.category) && values.category.length === 0
          ? JSON.stringify([])
          : values.category === 'all'
          ? 'all'
          : JSON.stringify(values.category)
        : Selectedcategories === 'all'
        ? 'all'
        : Array.isArray(Selectedcategories) && Selectedcategories.length === 0
        ? JSON.stringify([])
        : JSON.stringify(Selectedcategories)
    );

    formDataToSend.append(
      'sel_selection',
      values.sel !== undefined
        ? Array.isArray(values.sel) && values.sel.length === 0
          ? JSON.stringify([])
          : values.sel === 'all'
          ? 'all'
          : JSON.stringify(values.sel)
        : Selectedsells === 'all'
        ? 'all'
        : Array.isArray(Selectedsells) && Selectedsells.length === 0
        ? JSON.stringify([])
        : JSON.stringify(Selectedsells)
    );
    formDataToSend.append('current_selection', currentSelection);

    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      body: formDataToSend,
      headers: myHeaders
    };

    fetch(api.get_subproject_filters, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to fetch Deal data');
        }
      })
      .then((result_) => {
        if (thisRequest !== latestFilterRequest.current) return;
        const result = JSON.parse(result_);

        // currentSelection variable yahan available hai
        // Agar all hai, sab update karo
        // Agar kisi ka naam hai, uski list update mat karo

        if (currentSelection === 'all' || !currentSelection) {
          setSubProjectsList(result?.sub_projects);
          setTaskCodesList(result?.task_codes);
          setTaskNamesList(result?.task_names);
          setTaskDescriptionsList(result?.task_descriptions);
          setCategoriesList(result?.categories);
          setSellsList(result?.sells);
        } else {
          if (currentSelection !== 'sub_project') setSubProjectsList(result?.sub_projects);
          if (currentSelection !== 'code') setTaskCodesList(result?.task_codes);
          if (currentSelection !== 'name') setTaskNamesList(result?.task_names);
          if (currentSelection !== 'description')
            setTaskDescriptionsList(result?.task_descriptions);
          if (currentSelection !== 'category') setCategoriesList(result?.categories);
          if (currentSelection !== 'sel') setSellsList(result?.sells);
        }

        handleSelection({
          selectionValue: result?.sub_project_selection,
          itemsList: result?.sub_projects,
          setSelectedState: setSelectedSubProjects,
          setTempSelectedState: setTempSelectedSubProjects
        });

        // const taskCodesValue =
        //   result?.task_code_selection === 'all'
        //     ? 'all'
        //     : JSON.parse(result?.task_code_selection || '[]');
        // setSelectedTaskCodes(taskCodesValue);
        // setTempSelectedTaskCodes(taskCodesValue);

        handleSelection({
          selectionValue: result?.task_code_selection,
          itemsList: result?.task_codes,
          setSelectedState: setSelectedTaskCodes,
          setTempSelectedState: setTempSelectedTaskCodes
        });

        // const taskNamesValue =
        //   result?.task_name_selection === 'all'
        //     ? 'all'
        //     : JSON.parse(result?.task_name_selection || '[]');
        // setSelectedTaskNames(taskNamesValue);
        // setTempSelectedTaskNames(taskNamesValue);

        handleSelection({
          selectionValue: result?.task_name_selection,
          itemsList: result?.task_names,
          setSelectedState: setSelectedTaskNames,
          setTempSelectedState: setTempSelectedTaskNames
        });

        // const taskDescriptionsValue =
        //   result?.task_desc_selection === 'all'
        //     ? 'all'
        //     : JSON.parse(result?.task_desc_selection || '[]');
        // setSelectedTaskDescriptions(taskDescriptionsValue);
        // setTempSelectedTaskDescriptions(taskDescriptionsValue);

        handleSelection({
          selectionValue: result?.task_desc_selection,
          itemsList: result?.task_descriptions,
          setSelectedState: setSelectedTaskDescriptions,
          setTempSelectedState: setTempSelectedTaskDescriptions
        });

        // const categoriesValue =
        //   result?.category_selection === 'all'
        //     ? 'all'
        //     : JSON.parse(result?.category_selection || '[]');
        // setSelectedCategories(categoriesValue);
        // setTempSelectedCategories(categoriesValue);

        handleSelection({
          selectionValue: result?.category_selection,
          itemsList: result?.categories,
          setSelectedState: setSelectedCategories,
          setTempSelectedState: setTempSelectedCategories
        });

        // const sellsValue =
        //   result?.sel_selection === 'all' ? 'all' : JSON.parse(result?.sel_selection || '[]');
        // setSelectedSells(sellsValue);
        // setTempSelectedSells(JSON.parse(result?.sel_selection));

        handleSelection({
          selectionValue: result?.sel_selection,
          itemsList: result?.sells,
          setSelectedState: setSelectedSells,
          setTempSelectedState: setTempSelectedSells
        });
      })
      .catch((error) => {
        if (thisRequest !== latestFilterRequest.current) return;
        console.log('error', error);
      })
      .finally(() => {
        if (thisRequest !== latestFilterRequest.current) return;
        setloading(false);
      });
  }

  const refresh = () => {
    setlist([]);
    gstSubProjectList();
  };

  const handlePageChange = (event, newPage) => {
    setPagination((prev) => ({ ...prev, current_page: newPage }));
  };

  function handleFileUpload(e) {
    setuploadFileLoaderSub(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const file = e.target.files[0];

    const formData = new FormData();
    formData.append('file', file);
    formData.append('project_id', projectData?.id);

    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: myHeaders,
      body: formData
    };

    fetch(api.import_task, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setfileStatusSub(result?.data);
          getCurrentProcessingFileData();
        } else {
          toast.error(result.error);
        }
      })
      .catch((error) => {
        toast.error(error.error);
        console.log('error', error);
      })
      .finally(() => {
        setuploadFileLoaderSub(false);
      });
  }

  function getCurrentProcessingFileData() {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders
    };

    fetch(api.get_my_current_import, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to fetch Deal data');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setfileStatusSub(result?.data);
      })
      .catch((error) => {
        setfileStatusSub({});
      })
      .finally(() => {});
  }

  return (
    <Page title={`Sub-Projects | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: 2,
          padding: '0 10px'
        }}
      >
        {/* Back Button */}
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            color: '#000',
            mr: 1,
            p: 0.5,
            '&:hover': {
              backgroundColor: 'transparent',
              color: palette.primary.main
            }
          }}
        >
          <ArrowBackIcon sx={{ fontSize: 24 }} />
        </IconButton>

        {/* Heading */}
        <Typography
          sx={{
            fontSize: 25,
            fontFamily: 'poppinsSemiBold'
          }}
        >
          Sub Projects
        </Typography>
      </Box>

      <Grid xs={12} container spacing={2} alignItems="center" sx={{ mb: 1, padding: '0 0 0 13px' }}>
        <Grid item xs={12} md={4} lg={4} sm={4}>
          <FilterMultiDropdown
            label="Sub Projects"
            name="sub_projects"
            multiple
            value={
              SelectedsubProjects === 'all' ? subProjectsList.map((o) => o.id) : SelectedsubProjects
            }
            onChange={(e) => {
              const selected = e.target.value;
              const allValues = subProjectsList.map((o) => o.id);
              let newValue;
              if (selected.length === 0) {
                newValue = [];
              } else if (selected.length === allValues.length) {
                newValue = 'all';
              } else {
                newValue = selected.map((item) => (typeof item === 'object' ? item.value : item));
              }
              setSelectedSubProjects(newValue);
            }}
            onClickDone={() => {
              setSelectedSubProjects(SelectedsubProjects);
              setIsDropdownOpen(false); // mark as handled
              getAllFiltersDropDown('sub_project', {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
              gstSubProjectList(1, {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
            }}
            onOpen={() => {
              setIsDropdownOpen(true);
            }}
            onClose={() => {
              if (isDropdownOpen) {
                setSelectedSubProjects(tempSelectedSubProjects);
                setIsDropdownOpen(false);
              }
            }}
            showNameTag={false}
            options={subProjectsList?.map((val) => ({
              value: val.id,
              name: val.value
            }))}
            renderValue={(selected) =>
              SelectedsubProjects === 'all'
                ? 'All'
                : selected.length === 0
                ? 'None'
                : `${selected.length} selected`
            }
            error={false}
            helperText=""
            placeholder=""
            labelFontMedium
            marginBottom={'0rem'}
          />
        </Grid>

        <Grid item xs={12} md={4} lg={4} sm={4}>
          <FilterMultiDropdown
            label="Task Code"
            name="task_codes"
            multiple
            value={SelectedtaskCodes === 'all' ? taskCodesList.map((o) => o.id) : SelectedtaskCodes}
            onChange={(e) => {
              const selected = e.target.value;
              const allValues = taskCodesList.map((o) => o.id);
              let newValue;
              if (selected.length === 0) {
                newValue = [];
              } else if (selected.length === allValues.length) {
                newValue = 'all';
              } else {
                newValue = selected.map((item) => (typeof item === 'object' ? item.value : item));
              }
              setSelectedTaskCodes(newValue);
            }}
            onClickDone={() => {
              setSelectedTaskCodes(SelectedtaskCodes);
              setIsDropdownOpen(false); // mark as handled
              getAllFiltersDropDown('code', {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
              gstSubProjectList(1, {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
            }}
            onOpen={() => {
              setIsDropdownOpen(true);
            }}
            onClose={() => {
              if (isDropdownOpen) {
                setSelectedTaskCodes(tempSelectedTaskCodes);
                setIsDropdownOpen(false);
              }
            }}
            showNameTag={false}
            options={taskCodesList?.map((val) => ({
              value: val.id,
              name: val.value
            }))}
            renderValue={(selected) =>
              SelectedtaskCodes === 'all'
                ? 'All'
                : selected.length === 0
                ? 'None'
                : `${selected.length} selected`
            }
            error={false}
            helperText=""
            placeholder=""
            labelFontMedium
            marginBottom={'0rem'}
          />
        </Grid>

        <Grid item xs={12} md={4} lg={4} sm={4}>
          <FilterMultiDropdown
            label="Task Name"
            name="task_names"
            multiple
            value={SelectedtaskNames === 'all' ? taskNamesList.map((o) => o.id) : SelectedtaskNames}
            onChange={(e) => {
              const selected = e.target.value;
              const allValues = taskNamesList.map((o) => o.id);
              let newValue;
              if (selected.length === 0) {
                newValue = [];
              } else if (selected.length === allValues.length) {
                newValue = 'all';
              } else {
                newValue = selected.map((item) => (typeof item === 'object' ? item.value : item));
              }
              setSelectedTaskNames(newValue);
            }}
            onClickDone={() => {
              setSelectedTaskNames(SelectedtaskNames);
              setIsDropdownOpen(false); // mark as handled
              getAllFiltersDropDown('name', {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
              gstSubProjectList(1, {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
            }}
            onOpen={() => {
              setIsDropdownOpen(true);
            }}
            onClose={() => {
              if (isDropdownOpen) {
                setSelectedTaskNames(tempSelectedTaskNames);
                setIsDropdownOpen(false);
              }
            }}
            showNameTag={false}
            options={taskNamesList?.map((val) => ({
              value: val.id,
              name: val.value
            }))}
            renderValue={(selected) =>
              SelectedtaskNames === 'all'
                ? 'All'
                : selected.length === 0
                ? 'None'
                : `${selected.length} selected`
            }
            error={false}
            helperText=""
            placeholder=""
            labelFontMedium
            marginBottom={'0rem'}
          />
        </Grid>

        <Grid item xs={12} md={4} lg={4} sm={4}>
          <FilterMultiDropdown
            label="Task Description"
            name="task_descriptions"
            multiple
            value={
              SelectedtaskDescriptions === 'all'
                ? taskDescriptionsList.map((o) => o.id)
                : SelectedtaskDescriptions
            }
            onChange={(e) => {
              const selected = e.target.value;
              const allValues = taskDescriptionsList.map((o) => o.id);
              let newValue;
              if (selected.length === 0) {
                newValue = [];
              } else if (selected.length === allValues.length) {
                newValue = 'all';
              } else {
                newValue = selected.map((item) => (typeof item === 'object' ? item.value : item));
              }
              setSelectedTaskDescriptions(newValue);
            }}
            onClickDone={() => {
              setSelectedTaskDescriptions(SelectedtaskDescriptions);
              setIsDropdownOpen(false); // mark as handled
              getAllFiltersDropDown('description', {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
              gstSubProjectList(1, {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
            }}
            onOpen={() => {
              setIsDropdownOpen(true);
            }}
            onClose={() => {
              if (isDropdownOpen) {
                setSelectedTaskDescriptions(tempSelectedTaskDescriptions);
                setIsDropdownOpen(false);
              }
            }}
            showNameTag={false}
            options={taskDescriptionsList?.map((val) => ({
              value: val.id,
              name: val.value
            }))}
            renderValue={(selected) =>
              SelectedtaskDescriptions === 'all'
                ? 'All'
                : selected.length === 0
                ? 'None'
                : `${selected.length} selected`
            }
            error={false}
            helperText=""
            placeholder=""
            labelFontMedium
            marginBottom={'0rem'}
          />
        </Grid>

        <Grid item xs={12} md={4} lg={4} sm={4}>
          <FilterMultiDropdown
            label="Category"
            name="categories"
            multiple
            value={
              Selectedcategories === 'all' ? categoriesList.map((o) => o.id) : Selectedcategories
            }
            onChange={(e) => {
              const selected = e.target.value;
              const allValues = categoriesList.map((o) => o.id);
              let newValue;
              if (selected.length === 0) {
                newValue = [];
              } else if (selected.length === allValues.length) {
                newValue = 'all';
              } else {
                newValue = selected.map((item) => (typeof item === 'object' ? item.value : item));
              }
              setSelectedCategories(newValue);
            }}
            onClickDone={() => {
              setTempSelectedCategories(Selectedcategories);
              setIsDropdownOpen(false); // mark as handled
              getAllFiltersDropDown('category', {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
              gstSubProjectList(1, {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
            }}
            onOpen={() => {
              setIsDropdownOpen(true);
            }}
            onClose={() => {
              if (isDropdownOpen) {
                setSelectedCategories(tempSelectedCategories);
                setIsDropdownOpen(false);
              }
            }}
            showNameTag={false}
            options={categoriesList?.map((val) => ({
              value: val.id,
              name: val.value
            }))}
            renderValue={(selected) =>
              Selectedcategories === 'all'
                ? 'All'
                : selected.length === 0
                ? 'None'
                : `${selected.length} selected`
            }
            error={false}
            helperText=""
            placeholder=""
            labelFontMedium
            marginBottom={'0rem'}
          />
        </Grid>

        <Grid item xs={12} md={4} lg={4} sm={4}>
          <FilterMultiDropdown
            label="Sel"
            name="sells"
            multiple
            value={Selectedsells === 'all' ? sellsList.map((o) => o.id) : Selectedsells}
            onChange={(e) => {
              const selected = e.target.value;
              const allValues = sellsList.map((o) => o.id);
              let newValue;
              if (selected.length === 0) {
                newValue = [];
              } else if (selected.length === allValues.length) {
                newValue = 'all';
              } else {
                newValue = selected.map((item) => (typeof item === 'object' ? item.value : item));
              }
              setSelectedSells(newValue);
            }}
            onClickDone={() => {
              // Done press → confirm selection, API call
              setTempSelectedSells(Selectedsells); // 👈 yahan add karo
              setIsDropdownOpen(false); // mark as handled
              getAllFiltersDropDown('sel', {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
              gstSubProjectList(1, {
                sub_project: SelectedsubProjects,
                task_code: SelectedtaskCodes,
                task_name: SelectedtaskNames,
                task_desc: SelectedtaskDescriptions,
                category: Selectedcategories,
                sel: Selectedsells
              });
            }}
            onOpen={() => {
              setIsDropdownOpen(true);
            }}
            onClose={() => {
              if (isDropdownOpen) {
                setSelectedSells(tempSelectedSells);
                setIsDropdownOpen(false);
              }
            }}
            showNameTag={false}
            options={sellsList?.map((val) => ({
              value: val.id,
              name: val.value
            }))}
            renderValue={(selected) =>
              Selectedsells === 'all'
                ? 'All'
                : selected.length === 0
                ? 'None'
                : `${selected.length} selected`
            }
            error={false}
            helperText=""
            placeholder=""
            labelFontMedium
            marginBottom={'0rem'}
          />
        </Grid>
      </Grid>

      <Box sx={{ mx: 1.5, my: 1 }}>
        <Grid container spacing={2} alignItems="center" justifyContent={'flex-end'} mb={1} mt={1}>
          {/* Add Button */}
          {permission.includes('add sub project') && (
            <Grid item xs={12} md={1}>
              <Button
                fullWidth
                variant="contained"
                disabled={uploadFileLoaderSub}
                startIcon={<Iconify icon="ic:round-plus" sx={{ fontSize: 19, mr: -0.5 }} />}
                sx={{
                  fontSize: 12,
                  color: palette.primary.primary,
                  fontFamily: 'poppinsLight',
                  borderRadius: 0.7,
                  mb: { xs: 1, md: 0 }
                }}
                onClick={() => {
                  setShowAddEditModal(true);
                }}
              >
                Add
              </Button>
            </Grid>
          )}
          {/* UPLOAD FILE */}
          {permission.includes('upload file') && (
            <Grid item xs={12} md={1.5}>
              <LoadingButton
                fullWidth
                variant="contained"
                loading={uploadFileLoaderSub}
                disabled={
                  (fileStatusSub?.status == 'processing' && fileStatusSub?.type == 'sub_project') ||
                  uploadFileLoaderSub ||
                  fileStatusSub?.type == 'project' ||
                  loading
                }
                startIcon={
                  <Iconify icon="basil:file-upload-solid" sx={{ fontSize: 19, mr: -0.5 }} />
                }
                sx={{
                  fontSize: 12,
                  color: palette.primary.primary,
                  fontFamily: 'poppinsLight',
                  borderRadius: 0.7,
                  mb: { xs: 1, md: 0 }
                }}
                component="label"
              >
                Upload File
                <input type="file" hidden accept=".xlsx,.xls,.csv" onChange={handleFileUpload} />
              </LoadingButton>
            </Grid>
          )}
        </Grid>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            sx={{
              mb: 1.5,
              fontFamily: 'poppinsBold',
              color: palette.primary.titledark,
              fontSize: 20
            }}
          >
            Project:
          </Typography>
          <Typography
            sx={{
              mb: 1.5,
              fontFamily: 'poppinsBold',
              color: palette.primary.main,
              fontSize: 20,
              ml: 1
            }}
          >
            {projectData?.name}
          </Typography>
        </Box>

        {fileStatusSub?.status == 'processing' && fileStatusSub?.type == 'sub_project' && (
          <Card
            sx={{
              mb: 3,
              py: 1,
              px: 2,
              borderRadius: 1,
              boxShadow: '1px 2px 13px 0px rgba(0,0,0,0.1)',
              backgroundColor: palette.primary.lighterMain
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Typography
                sx={{
                  fontSize: 13,
                  fontFamily: 'poppinsMedium',
                  color: palette.primary.main
                }}
              >
                File Upload Status
              </Typography>

              <Box sx={{ display: 'flex', gap: 2.5, alignItems: 'center' }}>
                {/* <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: 'poppinsMedium',
                      color: palette.primary.titledark,
                      mb: 0.5
                    }}
                  >
                    Total Records
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontFamily: 'poppinsBold', color: palette.primary.main }}
                  >
                    {fileStatusSub?.total_records}
                  </Typography>
                </Box> */}
                <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: 'poppinsMedium',
                      color: palette.primary.titledark,
                      mb: 0.5
                    }}
                  >
                    Processed
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontFamily: 'poppinsBold', color: palette.success.main }}
                  >
                    {fileStatusSub?.processed_records}
                  </Typography>
                </Box>

                <Box sx={{ textAlign: 'center', ml: 4 }}>
                  <Typography
                    sx={{ fontFamily: 'poppinsLight' }}
                    className={
                      (fileStatusSub?.status?.toLowerCase() == 'complete' && 'status-green') ||
                      (fileStatusSub?.status?.toLowerCase() == 'processing' && 'status-pending')
                    }
                  >
                    {fileStatusSub?.status || 'N/A'}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Card>
        )}

        <SubProjectTable
          data={list}
          refresh={refresh}
          loading={loading}
          handlePageChange={handlePageChange}
          pagination={pagination}
          projectData={projectData}
          permission={permission}
        />
      </Box>

      {fileStatusSub?.type == 'sub_project' && (
        <Dialog open={showSuccessModalSub} onClose={() => setshowSuccessModalSub(false)}>
          <DialogTitle
            sx={{
              fontFamily: 'poppinsBold',
              fontSize: 18,
              textAlign: 'center',
              color: palette.primary.main
            }}
          >
            Import Successfull
          </DialogTitle>
          <DialogContent>
            <Typography
              sx={{ fontFamily: 'poppinsMedium', fontSize: 15, mb: 2, textAlign: 'center' }}
            >
              {fileStatusSub?.processed_records} records imported successfully
            </Typography>
            <Typography sx={{ fontFamily: 'poppinsRegular', fontSize: 13, textAlign: 'center' }}>
              page will refresh in {successTimerSub} seconds...
            </Typography>
          </DialogContent>
        </Dialog>
      )}

      {/* ADD MODAL */}
      <AddEditSubProjectModal
        open={showAddEditModal}
        onClose={() => setShowAddEditModal(false)}
        refresh={refresh}
        projectData={projectData}
      />

      <LoaderModal open={loading} />
    </Page>
  );
}
